import React, { useState, useEffect } from "react";
import { Line, Pie, Column } from "@ant-design/charts";
import { uniq, findIndex } from '@antv/util';

export default function LineGraph(props) {
  const {data} = props;
  const colors = [
    'red',
    'yellow',
    'green',
  ];
  const config = {
    data,
    height: 400,
    color:colors,

    xField: "position",
    yField: "weight",
    seriesField: 'category',
    point: {
      size: 5,
      shape: ({ category }) => {
        return category === '0' 
        ? 'square' 
        :(category === '1')
        ? 'circle'
        :(category === '2')
        ? 'diamond'
        :(category === '3')
        ? 'square'
        :(category === '4')
        ? 'circle'
        :'diamond';
      },
    },
    // yAxis: {
    //   label: {
    //     formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
    //   },
    // },
    /* tooltip: {
      formatter: (data) => {
        return {
          value: data.value,
        };
      },
      customContent: (name, data) =>
        `<style>
          .div-1 {
            background-color: white;
          }
    </style>
    <div className = "div-1" >${data?.map((item) => {
      return `<div >
              
              <span >${item?.value}</span>
            </div>`;
    })}</div>`,
      showMarkers: true,
      showContent: true,
      position: "left",
      showCrosshairs: true,
    }, */
  };

  return (
    <>
      <Line {...config} />
      {/* <DemoPie />
      <DemoColumn /> */}
    </>
  );
}
